export default __webpack_public_path__ + "static/media/placeholder.d48b39a3.webp";